import { useSession } from "./useSession";

export function useSessionId() {
    return useSession().id;
}
